var lydz = {


    paichepaisiji: {
        name: '派车派司机',
        key: 'paichepaisiji',
    },

    qianzi: {
        name: '负责人签字',
        key: 'qianzi',

    },
    jieshu: {
        name: '结束工单',
        key: 'jieshu',


    },
    empty: {},
};

export default lydz;


// WEBPACK FOOTER //
// ./src/components/wuliu/caiwufeiyong/rule.js